import styled, { css } from 'styled-components';
import BodyCopy from '@tcp/core/src/components/common/atoms/BodyCopy/views/index.js';
import { getIconPath } from '@tcp/core/src/utils';

const ICON_NAME = 'icon-carrot-grey-large';

export const AiRecommendationsWrapper = styled.div`
  margin: 24px 0 24px;
  @media ${(props) => props.theme.mediaQuery.smallMax} {
    margin: 16px 0 16px 14px;
  }
`;

export const RecommendationsHeader = styled(BodyCopy)`
  margin: 0 0 16px;
`;

export default css`
  .ai-recommendations-header {
    margin-top: 24px;
  }
  .visually-similar-carousel {
    margin-bottom: 24px;
    @media ${(props) => props.theme.mediaQuery.smallMax} {
      margin-bottom: 16px;
    }

    .tab-product-section {
      padding: 0;
    }

    .tab-added-to-bag {
      width: 44px;
      height: 44px;
      margin-right: 16px;
      @media ${(props) => props.theme.mediaQuery.smallMax} {
        width: 32px;
        height: 32px;
      }
    }

    .tab-atb-icon-image {
      width: 44px;
      height: 44px;
      @media ${(props) => props.theme.mediaQuery.smallMax} {
        width: 32px;
        height: 32px;
      }
    }

    .carousel-content {
      gap: 0;
      @media (min-width: 340px) and (max-width: 1200px) {
        overflow-x: auto;
      }
    }

    .tile-wrapper {
      flex: ${(props) => (props?.pageName === 'added_to_bag' ? '0 0 153px' : '0 0 163px')};
      min-height: ${(props) => (props?.pageName === 'added_to_bag' ? '287px' : '299px')};
      margin-right: ${(props) => (props?.pageName === 'added_to_bag' ? '8px' : 0)};
      width: 265px;
      padding: 0;
      border: 0;
      gap: 0;
      @media ${(props) => props.theme.mediaQuery.large} {
        min-width: 265px;
        margin-right: ${(props) => props.theme.spacing.ELEM_SPACING.MED_1};
      }

      @media (min-width: 340px) and (max-width: 380px) {
        flex: 0 0 153px;
        min-height: 287px;
        margin-right: 8px;
        gap: 0;
      }

      @media (min-width: 350px) and (max-width: 450px),
        (min-width: 760px) and (max-width: 850px),
        (min-width: 910px) and (max-width: 960px) {
        margin-right: 8px;
      }

      @media (min-width: 500px) and (max-width: 550px),
        (min-width: 680px) and (max-width: 730px),
        (min-width: 850px) and (max-width: 900px),
        (min-width: 1024px) and (max-width: 1064px) {
        flex: 0 0 175px;
        min-height: 314px;
        margin-right: 8px;
        gap: 0;
      }
    }

    .tab-product-img {
      display: block;
      width: 100%;
      position: relative;
      overflow: hidden;
      margin-bottom: 12px;
      @media ${(props) => props.theme.mediaQuery.smallMax} {
        margin-bottom: 8px;
      }
    }

    .moduleTabbed_carousel_img {
      width: 100%;
      background-color: rgb(235, 235, 235);
      @media ${(props) => props.theme.mediaQuery.large} {
        max-width: unset;
      }

      @media (min-width: 1024px) and (max-width: 1064px),
        (min-width: 500px) and (max-width: 550px),
        (min-width: 850px) and (max-width: 900px) {
        max-width: unset;
      }
    }

    .carousel-arrows .right-arrow {
      position: absolute; /* Assuming you want to position it absolutely */
      right: 26px;
      width: 40px;
      height: 40px;
      border-radius: 6px;
      border: 1px solid #d8d8d8; /* Use hex for consistency */
      background-color: rgba(255, 255, 255, 0.9);
      background-image: url(${(props) => getIconPath(ICON_NAME, props)});
      background-position: center;
      background-repeat: no-repeat;
    }

    .carousel-arrows .left-arrow {
      position: absolute; /* Assuming you want to position it absolutely */
      left: 26px;
      width: 40px;
      height: 40px;
      border-radius: 6px;
      border: 1px solid #d8d8d8; /* Use hex for consistency */
      background-color: rgba(255, 255, 255, 0.9);
      background-image: url(${(props) => getIconPath(ICON_NAME, props)});
      background-position: center;
      background-repeat: no-repeat;
      z-index: 10;
    }
  }
`;
